import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import InfoCard from "../../Cards/InfoCard/InfoCard";

// styles
import * as styles from "./DataPrivacy.module.css";

const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  sectionTitle: PropTypes.string,
  bottomText: PropTypes.string,
};

const defaultProps = {
  title: "Data Privacy & Security for Insurance Partners",
  subtitle: "Built on Trust. Secured by Design.",
  description:
    "At Twin Health in India, protecting member data is our top priority. We meet global standards in data privacy and security to keep every record safe.",
  sectionTitle: "We comply with",
  bottomText:
    "All data is encrypted, stored securely, and used only to improve member health and never for commercial use.",
};

const DataPrivacy = ({
  title,
  subtitle,
  description,
  sectionTitle,
  bottomText,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Compliance cards - no icons, just text
  const complianceCards = [
    {
      icon: "", // No icon needed
      title: "HIPAA (U.S.)",
      iconAlt: "HIPAA compliance",
    },
    {
      icon: "",
      title: "ISO/IEC 27001",
      iconAlt: "ISO/IEC 27001 compliance",
    },
    {
      icon: "",
      title: "GDPR (EU)",
      iconAlt: "GDPR compliance",
    },
    {
      icon: "",
      title: "Indian data protection laws",
      iconAlt: "Indian data protection laws compliance",
    },
  ];

  return (
    <section className={styles.dataPrivacyWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
          <p className={styles.description}>{description}</p>
        </div>

        {/* Section Title */}
        <div className={styles.sectionTitleWrapper}>
          <h3 className={styles.sectionTitle}>{sectionTitle}</h3>
        </div>

        {/* Compliance Cards */}
        <div className={styles.cardsSection}>
          <InfoCard
            cards={complianceCards}
            backgroundColor="#373049"
            columns={4}
            iconAlign="center"
          />
        </div>

        {/* Bottom Text */}
        <div className={styles.bottomTextWrapper}>
          <p className={styles.bottomText}>{bottomText}</p>
        </div>
      </div>
    </section>
  );
};

DataPrivacy.propTypes = propTypes;
DataPrivacy.defaultProps = defaultProps;

export default DataPrivacy;
